<template>
  <div class="orders-full-width-search-input-component">
    <v-text-field
      v-model="search"
      :disabled="disabled"
      class="search-text-field"
      label="Поиск по номеру телефона или номеру заказа"
      hide-details="auto"
      flat
      solo
      height="60"
      clearable
      @click:clear="handleClear"
      @keydown.enter="emitSearch"
      @input="emitClearIfEmpty"
    >
      <template v-slot:prepend-inner>
        <div class="search-type">
          <font-awesome-icon
            v-if="!search"
            class="search-icon"
            icon="search"
          />
          <search-type-icon
            v-else
            :search-string="search"
          />
        </div>
      </template>
      <template v-slot:append>
        <v-btn
          depressed
          class="emit-search-btn"
          color="primary"
          :class="{ 'emit-search-btn-disabled': !allowSearch }"
          :disabled="!allowSearch"
          @click="emitSearch"
        >
          Найти
        </v-btn>
      </template>
    </v-text-field>
  </div>
</template>

<script>
  import { ClickOutside } from 'vuetify/es5/directives'
  import SearchTypeIcon from '@/components/icons/SearchTypeIcon.vue'
  import {
    MIN_SEARCH_LENGTH,
    buildOrdersQuery,
    getFilterToPreserve,
    getSearchFromRoute,
    pushOrdersRoute,
  } from '@/util/orders-route'

  export default {
    name: 'OrdersFullWidthSearchInput',
    components: { SearchTypeIcon },
    directives: { ClickOutside },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        search: getSearchFromRoute(this.$route),
      }
    },
    computed: {
      allowSearch () {
        return (this.search?.length || 0) >= MIN_SEARCH_LENGTH
      },
    },
    watch: {
      '$route.query.search' () {
        this.search = getSearchFromRoute(this.$route)
      },
    },
    methods: {
      emitSearch () {
        if (!this.allowSearch) {
          return
        }
        pushOrdersRoute(this.$router, buildOrdersQuery({
          search: this.search,
          filter: getFilterToPreserve(this.$route),
        }))
      },
      handleClear () {
        this.search = null
        this.clearSearchInRoute()
      },
      emitClearIfEmpty () {
        if (!this.search) {
          this.clearSearchInRoute()
        }
      },
      clearSearchInRoute () {
        if (!getSearchFromRoute(this.$route)) {
          return
        }
        pushOrdersRoute(this.$router, buildOrdersQuery({
          filter: getFilterToPreserve(this.$route),
        }))
      },
    },
  }
</script>

<style scoped lang="less">
.orders-full-width-search-input-component {

  .search-btn {
    min-width: 60px;

    ::v-deep {
      .v-btn__content {
        font-size: 21px;
      }
    }
  }
  .bar-button {
    height: 50px;
    font-size: 14px;
    background-color: @color-secondary !important;
    margin-right: 10px;
    border-radius: 5px;

    .media-xl({
      margin-right: 20px;
    });
  }

  .search-text-field {
    height: 60px;
    //margin-right: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    //border: 1px solid #c4cdd9;
    box-shadow: 0 0 0 1px #c4cdd9;

    &::v-deep {
      .v-input__slot {
        //background-color: @color-secondary !important;
        height: 50px;
      }

      label {
        color: #c4cdd9 !important;
      }

      .v-input__icon--clear {
        button {
          color: @color-pink !important;
          font-size: 20px;
          margin-right: 14px;
        }

      }

    }

    .emit-search-btn {
      cursor: pointer;
      transition: all 0.3s ease;
      //color: @color-primary;
      height: 62px;
      //width: 60px;
      min-width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 21px;
      text-transform: none;
      position: relative;
      margin-right: -13px;
      margin-top: -1px;
      border-radius: 0 5px 5px 0;
      //padding: 0;

      &:hover {
        background: #e3e4e7;
      }

      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 1px;
        top: 20%;
        bottom: 20%;
        left: 0px;
        background-color: #dbdfe6;
        opacity: 1;
      }

      &-disabled {
        //opacity: 0.5;
        cursor: not-allowed;
        color: rgba(0, 0, 0, 0.3);
      }
    }

    .search-type {
      //color: #7a7a7a;
      color: @color-primary;
      margin-right: 15px;
      margin-left: 3px;

      &-icon {
        transition: all 0.3s ease;
      }

      .search-icon {
        //color: @color-btn-grey;
        font-size: 20px;
      }
    }

    .media-lg({
      //display: none;
      margin-right: 0;
      width: 100%;
    });
  }
}

</style>
